import Cookie from 'js-cookie';

export const AUTH_STATUSES = {
  PENDING: 'PENDING',
  INITIAL: 'INITIAL',
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OUT: 'LOGGED_OUT',
};

export const loginUser = (token) => {
  Cookie.set('token', token);
};

export const loginAndRedirect = (token, path) => {
  loginUser(token);
  window.location = path;
};

export const logOut = () => {
  Cookie.remove('token');
  window.location.reload();
};

export const getUserToken = () => {
  return Cookie.get('token');
};

export const updateOrg = (org) => {
  Cookie.set('org', org);
  window.location.reload();
};
